<template>
  <div>
    <user-actions-component :selected-filters="selectedFilters"></user-actions-component>
    <section class="bg-white py-5" aria-label="Service provider details">
      <b-container>
        <b-row>
          <b-col sm="12" md="12" lg="2">
            <back-button></back-button>
          </b-col>
          <b-col sm="12" md="12" lg="8">
            <h1 class="organization-title mb-3">{{ organization.name }}</h1>
            <debug-bar :api-response="organization"></debug-bar>
            <list-info
              v-if="organization.service_taxonomys"
              :list-array="organization.service_taxonomys"
              value-name="name"
              id-name="id"
              parent-name="taxonomy"
            ></list-info>
            <list-info
              v-if="organization.service_areas"
              :list-array="organization.service_areas"
              value-name="service_area"
              id-name="id"
            ></list-info>
            <b-row class="bg-light mb-3">
              <b-col>
                <div class="service-provider-contact py-4 px-3">
                  <h3 class="h5">Contact details</h3>
                  <b-list-group>
                    <b-list-group-item v-if="organization.url" class="p-0 border-0 bg-light">
                      <b-icon icon="globe" class="mr-2"></b-icon>
                      <a :href="organization.url" itemprop="url">{{ organization.name }} website</a>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-col>
            </b-row>
            <div class="my-4" v-html="organization.description"></div>
          </b-col>
        </b-row>
        <b-row>
          <service-list
            v-for="service in organization.services"
            :key="service.id"
            :service="service"
          >
          </service-list>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import store from '@/store/'
import { mapGetters } from 'vuex'
import { FETCH_ORGANIZATION } from '@/store/actions.type.js'
import DebugBar from '@/components/DebugBar'
import ListInfo from '@/components/elements/ListInfo'
import ServiceList from '@/components/list/ServiceList'
import BackButton from '@/components/elements/BackButton'
import UserActionsComponent from '@/components/elements/UserActionsComponent.vue'

export default {
  name: 'Service',
  components: {
    DebugBar,
    ListInfo,
    ServiceList,
    BackButton,
    UserActionsComponent,
  },
  computed: {
    ...mapGetters(['organization']),
  },
  mounted() {
    store.dispatch(FETCH_ORGANIZATION, this.$router.history.current.params.id)
  },
}
</script>
